export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node.js",
  "Java",
  "Ruby",
  "Ruby on Rails",
  "Linux"
];


export const projects = [
  {
    title: "Covid Mapping",
    subtitle: "React",
    description:
      "Using the latest API data this tracks the latest data on Covid and maps to an interactive world map.",
    image: "./covid_mapping.png",
    link: "https://github.com/JD-Kelly/react-covid-mapping",
  },
  {
    title: "Hang-Git",
    subtitle: "React, Node.js",
    description:
      "An educational game built to help people get to grips with Git. Based on the classic hang-man game.",
    image: "./hang_git.png",
    link: "https://github.com/JD-Kelly/hang-git",
  },
  {
    title: "DebugDAO",
    subtitle: "React, Javascript",
    description:
      "A decentralized autonomous organization - connect your wallet, mint an NFT and see a DAO Dashboard",
    image: "./debugDAO.png",
    link: "https://unruffled-kepler-095ad0.netlify.app/",
  },
]




// WEBPACK FOOTER //
// ./src/data.js